import {MachineStatus} from '../../../shared-gen/Machine/Status/MachineStatus';
import {OpState} from '../../../shared-gen/Machine/Status/OpState';

export class MachineStatusFun {

    static offline(): MachineStatus {
        return {
            OpState: OpState.Offline,
            ServingStatus: null as any,
            ExState: null,
            RequestedProduct: null as any,
            Problems: [],
            Message: null as any,
            AvailableResources: [],
            FillLevels: { Selections: [] } as any
        }
    }

}
